<template>
  <component
    :is="isAuth ? 'a' : 'button'"
    v-bind="isAuth ? { href: urlLanguagePrefix + '/loyalty-program/' } : ''"
    v-on="!isAuth ? { click: openAuthModal } : ''"
    class="header-bonuses-info"
    :class="{'header-bonuses-info--changed-info': isChangedBonuses}"
  >
    <p class="header-bonuses-info__text" v-html="isAuth ? $t('header_bonuses_text') : $t('header_auth_bonuses_text')"></p>
    <div class="header-bonuses-info__icon-wrap">
      <img class="header-bonuses-info__icon" src="/img/svgo/product-page/bonus_icon.svg" alt="bonus-icon">
      <div v-if="(totalBonusesInCurrency || totalBonusesInCurrency === 0) && isAuth" class="header-bonuses-info__total-bonuses-wrap">
        <p class="header-bonuses-info__total-bonuses">
          {{ totalBonusesInCurrency | CurrencyFormatter }}
          <span class="header-bonuses-info__total-bonuses header-bonuses-info__total-bonuses--currency"> грн</span>
        </p>
      </div>
    </div>
  </component>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CurrencyFormatter from '@/filters/CurrencyFormatter'

export default {
  name: 'HeaderBonusesInfo',
  filters: {
    CurrencyFormatter
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isChangedBonuses', 'totalBonusesInCurrency']),
    ...mapState({
      userDataFromServer: state => state.user
    }),
    isAuth () {
      if (this.userDataFromServer.user_data || this.userDataFromServer.user_data === undefined) {
        return this.userDataFromServer.auth
      }
      return null
    }
  },
  methods: {
    openAuthModal () {
      this.$modal.show('auth-modal', {
        title: this.$t('header_auth_bonuses_text'),
        url: this.urlLanguagePrefix + '/loyalty-program/'
      })
    }
  }
}
</script>
